import {
	Directive,
	Input,
	OnInit,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';

import { ExperimentationService } from '@services/experimentation.service';

@Directive({
	standalone: false,
	selector: '[qeFlagEvaluate]',
})
export class FeatureFlagDirective implements OnInit {
	private _gate = '';
	private _isHidden = true;

	@Input() set qeFlagEvaluate(val: string) {
		if (val) {
			this._gate = val;
			this._updateView();
		}
	}

	constructor(
		private readonly _templateRef: TemplateRef<unknown>,
		private readonly _viewContainer: ViewContainerRef,
		private readonly _experimentationService: ExperimentationService
	) {
		this._experimentationService.experimentationClient()?.$on('values_updated', () => {
			this._updateView();
		});
	}

	ngOnInit(): void {
		if (this._gate) {
			this._updateView();
		}
	}

	private _updateView() {
		if (this._experimentationService.isClientReady()) {
			if (this._checkGate()) {
				if (this._isHidden) {
					this._viewContainer.createEmbeddedView(this._templateRef);
					this._isHidden = false;
				}
			} else {
				this._viewContainer.clear();
				this._isHidden = true;
			}
		}
	}

	private _checkGate() {
		return (
			this._gate && this._experimentationService?.getFeatureFlag(this._gate)
		);
	}
}
